var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landing"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.doClick($event)}}},[_c('img',{attrs:{"src":"static/img/cover.jpg"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }